import React from "react";
import PropTypes from "prop-types";
import { RichUtils } from "draft-js";

const Toolbar = ({ editorState, setEditorState }) => {
	// For more tools refer to: https://www.npmjs.com/package/react-draft-wysiwyg
	const tools = [
		{
			label: "bold",
			style: "BOLD",
			icon: <i className="glyphicon glyphicon-bold" />,
			method: "inline",
		},
		{
			label: "italic",
			style: "ITALIC",
			icon: <i className="glyphicon glyphicon-italic" />,
			method: "inline",
		},
		{
			label: "Unordered-List",
			style: "unordered-list-item",
			icon: <i className="glyphicon glyphicon-list" />,
			method: "block",
		},
	];

	const isActive = (style, method) => {
		if (method === "block") {
			const selection = editorState.getSelection();
			const blockType = editorState
				.getCurrentContent()
				.getBlockForKey(selection.getStartKey())
				.getType();

			return blockType === style;
		}

		const currentStyle = editorState.getCurrentInlineStyle();
		return currentStyle.has(style);
	};

	const applyStyle = (e, style, method) => {
		e.preventDefault();

		if (method === "block") {
			setEditorState(RichUtils.toggleBlockType(editorState, style));
		} else {
			setEditorState(RichUtils.toggleInlineStyle(editorState, style));
		}
	};

	return (
		<div className="toolbar-grid">
			<div
				className="btn-group"
				role="group"
			>
				{tools.map((item, idx) => (
					<button
						// eslint-disable-next-line react/no-array-index-key
						key={`${item.label}-${idx}`}
						style={{
							color: isActive(item.style, item.method)
								? "rgba(0, 0, 0, 1)"
								: "rgba(0, 0, 0, 0.3)",
						}}
						type="button"
						className="btn btn-default"
						onClick={e => applyStyle(e, item.style, item.method)}
						onMouseDown={e => e.preventDefault()}
					>
						{item.icon || item.label}
					</button>
				))}
			</div>
		</div>
	);
};

Toolbar.propTypes = {
	editorState: PropTypes.string.isRequired,
	setEditorState: PropTypes.func.isRequired,
};

export default Toolbar;
